import React from "react";
import clsx from "clsx";
import { isEmpty } from "lodash";
import { Row } from "react-bootstrap";

import {
	StripedRow,
	StripedColumn,
	StripedRowsContainer,
	EmptyBlock,
} from "components";

import { StripedColumnDataType } from "./stripedColumn";

//	<!-- this component build on base of 3 small independent components (StripedRowsContainer, StripedRow and StripedColumn)
//	component expects to receive values from mapper in the array format
//	-->
//<StripedRowsWithCols
//	<!-- the number of columns is set manually to colsQty prop. this number should be not more 12 -->
//	colsQty={1}
//	items={ items: getMapper => [
//			{
//				row: [
//				<!-- each object of row array is separate column -->
//					{
//						label: "Label",
//						value: "value",
//						<!-- if value or label doesn`t exit column will expand on 100% (col-sm-12) -->
//					},
//				],
//			},
//		];}
// 	<!-- prop for set which bg color of striped table will be for first row -->
//  bgReverse
//>;

export type StripedRowsWithColsItemsType = {
	row: StripedColumnDataType[];
}[];

type columnsQuantityType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

type StripedRowsWithColsProps = {
	isLoading: boolean;
	isEditForm?: boolean;
	bgReverse?: boolean;
	items: StripedRowsWithColsItemsType;
	className?: string;
	stripedRowClassName?: string;
	valueContainerClassName?: string;
	colsQty: columnsQuantityType;
};

export const StripedRowsWithCols = ({
	isLoading = false,
	isEditForm = false,
	items,
	className,
	stripedRowClassName,
	valueContainerClassName,
	colsQty,
	bgReverse,
}: StripedRowsWithColsProps) => {
	return (
		<StripedRowsContainer className={clsx(className)} bgReverse={bgReverse}>
			{isEmpty(items) && !isEditForm ? (
				<EmptyBlock />
			) : (
				<>
					{items?.map(({ row }, index) => (
						<StripedRow
							key={index}
							className={clsx(stripedRowClassName)}
							content={
								<Row>
									{row?.map((col, i) => (
										<StripedColumn
											key={`${index}${i}`}
											columnData={col}
											colsQty={colsQty}
											isLoading={isLoading}
											isEditForm={isEditForm}
											valueContainerClassName={
												valueContainerClassName
											}
										/>
									))}
								</Row>
							}
						/>
					))}
				</>
			)}
		</StripedRowsContainer>
	);
};
